import { render, staticRenderFns } from "./ykcForm.vue?vue&type=template&id=356be792"
import script from "./ykcForm.vue?vue&type=script&lang=js"
export * from "./ykcForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports